import { ThemeUICSSObject } from '@apia/theme';
import { focusOutline, spacing } from '../../../../util';
/* IMPORT HERE */
export const form: ThemeUICSSObject = {
  /* PREPEND HERE */
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  gap: 0,
  mx: 'auto',
  background: 'palette.background.paper',
  border: '1px solid',
  borderColor: 'palette.border.section',
  borderRadius: 'panel',
  boxShadow: '0px 2px 6px #0002',
  width: '100%',
  p: spacing(3),
  flexDirection: 'column',
  position: 'relative',
  overflow: 'visible',

  '.pendingMessagesPanel': {
    bottom: 'calc(100% + 6px)',
    left: 0,
    minWidth: 0,
    overflow: 'visible',
    position: 'absolute',
    right: 0,
    zIndex: 1,
  },

  '.pendingMessagesPanel__stack': {
    background: 'palette.background.paper',
    border: '1px solid',
    borderColor: 'palette.border.section',
    borderRadius: 'panel',
    boxShadow: '0px 2px 6px #0002',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    maxWidth: '100%',
    minWidth: 0,
    p: 2,
    position: 'relative',
  },

  '.pendingMessagesPanel__message': {
    alignItems: 'center',
    background: 'transparent',
    border: '1px solid transparent',
    borderRadius: 'default',
    color: 'palette.text.primary',
    cursor: 'pointer',
    display: 'flex',
    font: 'inherit',
    gap: 2,
    minHeight: '24px',
    minWidth: 0,
    px: 2,
    py: 1,
    textAlign: 'left',
    width: '100%',

    '&:hover, &:focus-within': {
      background: 'palette.background.default',
      borderColor: 'palette.border.field',

      '.pendingMessagesPanel__actions': {
        opacity: 1,
        pointerEvents: 'auto',
      },
    },
  },

  '.pendingMessagesPanel__messageText': {
    flex: '1 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  '.pendingMessagesPanel__actions, .pendingMessagesPanel__editActions': {
    alignItems: 'center',
    display: 'flex',
    flex: '0 0 auto',
    gap: 1,
  },

  '.pendingMessagesPanel__actions': {
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 120ms ease',

    '&:focus-within': {
      opacity: 1,
      pointerEvents: 'auto',
    },
  },

  '.pendingMessagesPanel__action': {
    background: 'transparent',
    border: 'none',
    color: 'palette.text.disabled',
    height: '22px',
    minHeight: '22px',
    minWidth: '22px',
    width: '22px',

    '&:hover, &:focus': {
      background: 'palette.background.paper',
      color: 'palette.text.primary',
    },
  },

  '.pendingMessagesPanel__edit': {
    alignItems: 'flex-end',
    display: 'flex',
    gap: 2,
    minWidth: 0,
    width: '100%',
  },

  '.pendingMessagesPanel__textarea': {
    background: 'palette.background.paper',
    border: '1px solid',
    borderColor: 'palette.border.field',
    borderRadius: 'default',
    flex: '1 1 auto',
    fontFamily: 'inherit',
    maxHeight: '72px',
    minHeight: '28px',
    minWidth: 0,
    overflow: 'auto',
    px: 2,
    py: 1,
    resize: 'none',
  },

  '.pendingMessagesPanel__overflow': {
    position: 'relative',

    '&:hover, &:focus-within': {
      '.pendingMessagesPanel__overflowPopup': {
        opacity: 1,
        pointerEvents: 'auto',
        transform: 'translateY(-4px)',
      },
    },
  },

  '.pendingMessagesPanel__overflowTrigger': {
    alignItems: 'center',
    background: 'transparent',
    border: '1px solid transparent',
    borderRadius: 'default',
    color: 'palette.text.disabled',
    cursor: 'default',
    display: 'flex',
    fontWeight: 700,
    justifyContent: 'center',
    minHeight: '24px',
    px: 2,
    py: 1,

    '&:hover, &:focus': {
      background: 'palette.background.default',
      borderColor: 'palette.border.field',
      color: 'palette.text.primary',
    },
  },

  '.pendingMessagesPanel__overflowPopup': {
    background: 'palette.background.paper',
    border: '1px solid',
    borderColor: 'palette.border.section',
    borderRadius: 'panel',
    bottom: 'calc(100% + 6px)',
    boxShadow: '0px 4px 12px #0003',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    left: 0,
    maxHeight: '220px',
    minWidth: 0,
    opacity: 0,
    overflow: 'auto',
    p: 2,
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
    transform: 'translateY(0)',
    transition: 'opacity 120ms ease, transform 120ms ease',
    zIndex: 2,
  },

  '.chatInputRow': {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
    gap: 1,
    minWidth: 0,
    width: '100%',
  },

  '.chatButtons': {
    gap: 1,
    display: 'flex',
    flexDirection: 'row',
    flex: '0 0 auto',
    alignItems: 'end',
    justifyContent: 'end',
  },
  '&:focus-within': focusOutline,

  '& > *:focus[class]': {
    outlineWidth: 0,
  },

  '.filter_button_box': {
    position: 'relative',
  },
  '.applied_filters_label': {
    position: 'absolute',
    bottom: '21px',
    left: '20px',
    minWidth: '10px',
    maxHeight: '10px',
    border: '2px solid white',
    borderRadius: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'palette.error.main',
  },

  '.searchTextArea': {
    minHeight: '16px',
    height: '16px',
    flex: '1 1 auto',
    minWidth: 0,
    width: '100%',
    maxHeight: '30vh',
    resize: 'none',
    py: 0,
    background: 'transparent',
    border: 'none',

    '&:focus': {
      outline: 'none',
    },
  },

  '.ChatBarButton': {
    borderRadius: 'panel',
    height: '34px',
    width: '34px',
    flexShrink: 0,
    background: 'transparent',
    border: 'none',
    color: 'palette.text.primary',
  },
  '.isRecording': {
    borderRadius: 'panel',
    height: '34px',
    width: '34px',
    flexShrink: 0,
    background: 'transparent',
    border: 'none',
    color: 'red',
  },
};
